<template>
  <BaseVeeForm
    :action="submit"
    ensure-error-keys-camel-case
    v-slot="{ isPending, invalid }"
    @success="showActions = false"
  >
    <ValidationProvider rules="required" name="mediaId" slim vid="mediaId">
      <template #default="{ errors }">
        <BaseFormInput type="hidden" :value="mediaId" />
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </template>
    </ValidationProvider>
    <BaseButton primary small outline :disabled="isPending || invalid"> Delete </BaseButton>
  </BaseVeeForm>
</template>

<script>
import { accProductTemplateMediaClient } from '@/api/clients/admin';

export default {
  inject: ['refreshAccProductTemplate'],
  props: {
    accProductTemplateId: {
      type: String,
      required: true,
    },
    mediaId: {
      type: String,
      required: true,
    },
  },
  methods: {
    async submit() {
      try {
        await accProductTemplateMediaClient.destroy(this.accProductTemplateId, this.mediaId);
        await this.refreshAccProductTemplate();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
